import Barba from 'barba.js'
import $ from 'jquery'
import accordian from '../../modules/accordian.js'
import scrollTo from '../../modules/scroll-to.js'

var faqView = function() {

  var Faq = Barba.BaseView.extend({
    namespace: 'faq',
    onEnter: function() {
      accordian();
      scrollTo();
    },
    onEnterCompleted: function() {
      $(window).scroll();
    },
    onLeave: function() {
    },
    onLeaveCompleted: function() {
    }
  });

  Faq.init();
}

module.exports = faqView;



// WEBPACK FOOTER //
// ./resources/assets/js/barba/views/faq-view.js